/**
 * Customer login page JavaScript
 */
document.addEventListener('DOMContentLoaded', function() {
  const recoverPasswordForm = document.getElementById('RecoverPasswordForm');
  const customerLoginForm = document.getElementById('CustomerLoginForm');
  const resetSuccess = document.getElementById('ResetSuccess');
  
  // Check if we're on the recover password success page
  if (window.location.hash === '#recover' && recoverPasswordForm && customerLoginForm) {
    showRecoverPasswordForm();
  }

  // Toggle recover password form
  const recoverPasswordLink = document.getElementById('RecoverPassword');
  if (recoverPasswordLink && recoverPasswordForm && customerLoginForm) {
    recoverPasswordLink.addEventListener('click', function(event) {
      event.preventDefault();
      showRecoverPasswordForm();
    });
  }

  // Hide recover password form
  const hideRecoverPasswordLink = document.getElementById('HideRecoverPasswordLink');
  if (hideRecoverPasswordLink && recoverPasswordForm && customerLoginForm) {
    hideRecoverPasswordLink.addEventListener('click', function(event) {
      event.preventDefault();
      hideRecoverPasswordForm();
    });
  }

  // Show reset password success message.
  // Shopify reloads the login page after a successful recover-password post; the
  // form renders a `.reset-password-success` marker server-side in that case.
  // We also keep the legacy `reset_success=true` query-param check as a fallback.
  const resetMarker = document.querySelector('.reset-password-success');
  if ((resetMarker || window.location.search.includes('reset_success=true')) && resetSuccess) {
    resetSuccess.classList.remove('hidden');
    // Keep the user on the login form (not the recover form) so the message is visible.
    hideRecoverPasswordForm();
    // Auto-hide the success message after 8 seconds.
    setTimeout(function() {
      resetSuccess.classList.add('hidden');
    }, 8000);
  }
  
  function showRecoverPasswordForm() {
    if (recoverPasswordForm && customerLoginForm) {
      // Add animation classes
      recoverPasswordForm.classList.remove('hidden');
      recoverPasswordForm.classList.add('animate-fadeIn');
      customerLoginForm.classList.add('hidden');
    }
  }
  
  function hideRecoverPasswordForm() {
    if (recoverPasswordForm && customerLoginForm) {
      recoverPasswordForm.classList.add('hidden');
      recoverPasswordForm.classList.remove('animate-fadeIn');
      customerLoginForm.classList.remove('hidden');
      customerLoginForm.classList.add('animate-fadeIn');
      // Remove the animation class after animation completes
      setTimeout(function() {
        customerLoginForm.classList.remove('animate-fadeIn');
      }, 500);
    }
  }
});
